<template>
    <div :data-right-drawer="$store.getters.rightDrawerOpen ? 'open' : 'closed'">
        <Popover />
        <FlashMessages />
        <CustomWorkModal
            v-if="$store.getters.customWork.showModal"
            :initialPackage="$store.getters.customWork.initialPackage"
            :initialExecutives="$store.getters.customWork.initialExecutives"
        />
        <SearchResultsModal />
        <TopRail />
        <div id="app-layout">
            <LeftRail />
            <router-view class="flex-content" style="flex: 1" data-slot="targetContent" :id="$route.name"></router-view>
            <RightRail />
        </div>
    </div>
</template>
<script>
import CustomWorkModal from '@/components/CustomWork/CustomWorkModal'
import FlashMessages from './app/flash-messages.vue'
import LeftRail from './app/left-rail.vue'
import Popover from '@/components/popovers/popover.vue'
import RightRail from './app/right-rail.vue'
import SearchResultsModal from '@/components/Search/SearchResultsModal.vue'
import TopRail from './app/top-rail.vue'

export default {
    name: 'AppLayout',
    components: {
        CustomWorkModal,
        FlashMessages,
        LeftRail,
        Popover,
        RightRail,
        SearchResultsModal,
        TopRail,
    },
}
</script>
<style>
#app-layout {
    top: var(--top-rail-height);
    left: 0;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    overflow-x: hidden;
    width: 100vw;

    /* for some reason the /manage/executives page loses the id attribute */
    [data-slot='targetContent'],
    .flex-content {
        padding: var(--spacing-common);
    }
}

@media screen {
    #app-layout {
        [data-slot='targetContent'],
        .flex-content {
            overflow: auto;
        }
    }
}

@media screen {
    #app-layout {
        height: calc(100vh - var(--top-rail-height));
    }
}

.side-rail {
    background-color: var(--color-side-rail-background);
    position: relative;
    text-align: center;
    width: var(--side-rail-width);
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding-top: var(--spacing-common);

    ul {
        flex-basis: 100%;
    }

    li {
        display: block;
        margin: 0 auto var(--spacing-common);
    }

    .side-rail-lower-icons {
        flex-basis: 0px;
    }
}

@media print {
    .side-rail {
        display: none;
    }
}

@media (max-width: 640px) {
    #app-layout .flex-content {
        overflow: auto;
        padding: 24px !important;
    }
}
</style>
